import { render, staticRenderFns } from "./ReuseTab.vue?vue&type=template&id=e1452fc2&"
import script from "./ReuseTab.vue?vue&type=script&lang=tsx&"
export * from "./ReuseTab.vue?vue&type=script&lang=tsx&"
import style0 from "./ReuseTab.vue?vue&type=style&index=0&id=e1452fc2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports